// frontend/src/services/utils/logging.js

/**
 * Simple logging utility compatible with the existing code
 */
class Logger {
  constructor(moduleName) {
    this.moduleName = moduleName;
    this.logLevel = process.env.NODE_ENV === 'production' ? 'info' : 'debug';
  }

  /**
   * Format a log message with module name
   */
  _formatMessage(message) {
    return `[${this.moduleName}] ${message}`;
  }

  /**
   * Standard log method (matches what the code is expecting)
   */
  log(...args) {
    console.log(this._formatMessage(args[0]), ...args.slice(1));
  }

  /**
   * Debug level logging
   */
  debug(...args) {
    console.debug(this._formatMessage(args[0]), ...args.slice(1));
  }

  /**
   * Info level logging
   */
  info(...args) {
    console.info(this._formatMessage(args[0]), ...args.slice(1));
  }

  /**
   * Warning level logging
   */
  warn(...args) {
    console.warn(this._formatMessage(args[0]), ...args.slice(1));
  }

  /**
   * Error level logging
   */
  error(...args) {
    console.error(this._formatMessage(args[0]), ...args.slice(1));
  }
}

/**
 * Get a logger instance for a specific module
 * @param {string} moduleName - The name of the module using this logger
 * @returns {Logger} A configured logger instance
 */
function getLogger(moduleName) {
  return new Logger(moduleName);
}

export default {
  getLogger
};